module.exports = __webpack_public_path__ + "static/media/花泽香菜教你日语五十音（加长版）.663f79cc.flv";